<template>
  <div>
    <div class="section py-0 px-5">
      <div class="tile app-title">
        <p class="subtitle is-6">Ajouter un filtre</p>
      </div>
      <b-select v-model="selectedFiltreDynamique"
                :placeholder="listeFiltres[0]"
                expanded>
          <option
              v-for="filtre in listeFiltres"
              :value="filtre"
              :key="filtre">
              {{ filtre }}
          </option>
      </b-select>
    </div>
    <hr>
    <div :key="filtreReseaux.id" v-for="filtreReseaux in getFiltresDynamiquesReseaux">
      <component :is="filtreReseaux.app"
                 :propriete="filtreReseaux.id"
                 :label="filtreReseaux.label"/>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteReseauxNumerique-mutation-type';
import { FILTRE_DYNAMIQUE_VIDE } from '@/components/creationOpportunite/configuration/filtresConf';
import { TemplateFiltre, DataFiltre, ComputedFiltre, MethodsFiltre } from '@/components/general/baseFiltreDynamique';
import filtreAutoComplete from './filtreAutocomplete';

const VenteReseauxNumerique = createNamespacedHelpers('venteReseauxNumerique');
const filterComponents = {};

const ALL_FILTRES = [
  { key: 'format', title: 'Format' },
];

ALL_FILTRES.forEach((el) => {
  filterComponents[el.key] = {
    data: DataFiltre(el.key, el.title),
    computed: ComputedFiltre(VenteReseauxNumerique.mapGetters, 'filtresDynamiquesSpe'),
    methods: MethodsFiltre(VenteReseauxNumerique.mapMutations, VenteReseauxNumerique.mapActions,
      types.REMOVE_FILTER_PROPERTY, types.ADD_FILTER_PROPERTY, 'gestionFiltres'),
    template: TemplateFiltre,
  };
});


export default {
  name: 'ajout-filtre',
  components: {
    appFormat: filterComponents.format,
    appDepLibelle: filterComponents.depLibelle,
    appFiltreAutoComplete: filtreAutoComplete,
  },
  data() {
    return {
      filtreDynamiqueVisible: false,
      listeFiltres: [FILTRE_DYNAMIQUE_VIDE, 'Ville', 'Département', 'Format'],
    };
  },
  watch: {
    selectedFiltreDynamique() {
      const regAccentE = new RegExp('[éèêë]', 'gi');
      let value = this.selectedFiltreDynamique.toLowerCase().replace(regAccentE, 'e');
      if (value === 'departement') value = 'depCode';
      if (this.selectedFiltreDynamique !== FILTRE_DYNAMIQUE_VIDE) {
        let valueApp = value;
        if (value === 'ville' || value === 'depCode') valueApp = 'filtre-auto-complete';
        this.actionAjoutFiltresDynamiques({ property: value, valueProperty: { id: value, variable: value, valeur: [], app: 'app-' + valueApp } });
      }
    },
  },
  computed: {
    ...VenteReseauxNumerique.mapGetters({
      filtresDynamiques: 'filtresDynamiques',
      getSelectedFiltreDynamique: 'selectedFiltreDynamique',
    }),
    selectedFiltreDynamique: {
      get() {
        return this.getSelectedFiltreDynamique;
      },
      set(value) {
        this.setSelectFiltreDynamique(value);
      },
    },
    getFiltresDynamiquesReseaux() {
      const tab = this.filtresDynamiques;
      tab.forEach(el => {
        if (el.id === 'ville') el.label = 'Ville';
        if (el.id === 'depCode') el.label = 'Département';
      });
      return tab;
    },
  },
  methods: {
    ...VenteReseauxNumerique.mapMutations({
      setSelectFiltreDynamique: types.SELECT_FILTRE_DYNAMIQUE,
    }),
    ...VenteReseauxNumerique.mapActions({
      actionAjoutFiltresDynamiques: 'ajoutFiltresDynamiques',
    }),
  },
};
</script>

<style scoped>

  select {
    padding-left:10px;
    padding-right: 10px;
    -webkit-appearance: none;
    border: 1px solid #dbdbdb;
    color:#5E738B;
  }

  select:disabled{
    background-color: rgba(200, 200, 200, 0.2);
    border:none;
  }

  select:hover{
    border-color: #bfbfbf;
  }

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxNumerique/filtres/ajoutFiltre.vue